import { MutableRefObject, RefCallback } from 'react';

export const mergeRefs = <T extends HTMLElement | null>(refs: Array<MutableRefObject<T> | RefCallback<T> | null | undefined>) => {
    return (value: T) => {
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(value);

                return;
            }

            if (ref != null) {
                ref.current = value;
            }
        });
    };
};
